import { FC, useEffect, useMemo, useRef } from 'react';
import { ModelClusterInfo, ShopStatus } from './ts-config';
import { markerActiveColorOption, markerDefaultColorOption } from '@/common/enums/business/siteselectionmap';
import { isArray, isDef, isNotEmpty, isNotEmptyAny } from '@lhb/func';
import styles from './index.module.less';
import { Typography } from 'antd';
import ReactDOM from 'react-dom';
import cs from 'classnames';
import { showMarker } from '@/common/utils/map';
import IconFont from '@/common/components/IconFont';
import { useSelector } from 'react-redux';
// import { mapContainerAddress } from './CircleAddress';
export const mapContainerAddress = 'mapContainerAddress';

/**
 * @Description  匹配商圈组件的地图逻辑处理 --详情和表单都共用
 */
const MapOfCIrcleAddress: FC<{
  amapIns: any;
  clusterList: any;
  shopList: any;
  chancePoint: any;
}> = ({
  amapIns,
  clusterList,
  shopList,
  chancePoint
}) => {
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const businessOverLayers: any = useRef<any>(null);
  const shopMarkersRef: any = useRef<any>(null);
  const chancePointMarkerRef: any = useRef([]); // 机会点Marker
  const hoverMarkerRef = useRef(null);// hoverMarker

  /**
      * @description 是否摩可多租户
    */
  const isMKD = useMemo(() => {
    return !!tenantCheckData?.isMkd;
  }, [tenantCheckData]);

  // 创建周边商圈
  const updateClusterList = (list: any) => {
    if (businessOverLayers.current) {
      amapIns.remove(businessOverLayers.current);
      businessOverLayers.current = null;
    }
    if (!isArray(list)) return;
    let markers: any = []; // 所有商圈的围栏覆盖物
    list.forEach((cluster: ModelClusterInfo) => {
      let tempMarkers: any = [];
      const { radius, polygon } = cluster;
      if (radius) {
        tempMarkers = createBusinessCircle(cluster); // 绘制商圈围栏（圆）覆盖物
      } else if (isArray(polygon) && polygon.length) {
        tempMarkers = createBusinessPolygon(cluster);
      }
      markers = markers.concat(tempMarkers);
    });
    const overlayGroup = new window.AMap.OverlayGroup(markers); // 围栏覆盖物群组
    amapIns.add(overlayGroup); // 添加到地图
    businessOverLayers.current = overlayGroup;

    list.forEach((cluster: ModelClusterInfo) => {
      renderBusinessName(cluster.id, cluster.centerName, cluster.inCluster);
    });
  };
  // 创建圆形商圈
  const createBusinessCircle = (item: ModelClusterInfo) => {
    const { centerLng, centerLat } = item;
    if (!(isNotEmpty(centerLng) && isNotEmpty(centerLat))) return;
    const lnglat = [+centerLng, +centerLat];
    const fillColor = item.inCluster ? markerActiveColorOption : markerDefaultColorOption;
    const circle = new window.AMap.Circle({
      center: lnglat,
      radius: item?.radius, // 半径（米）
      strokeWeight: 1,
      strokeOpacity: 1,
      fillOpacity: 0.2,
      strokeStyle: 'dashed',
      strokeDasharray: [10, 10],
      bubble: true, // 为了支持在商圈围栏上测距
      extData: item,
      ...fillColor,
    });
    const marker = new window.AMap.Marker({
      position: lnglat,
      anchor: 'center',
      extData: item,
      content: `<div id="${item.id}"></div>`,
      bubble: true,
      zIndex: 20,
    });
    return [circle, marker];
  };
    // 创建多边形商圈
  const createBusinessPolygon = (item: ModelClusterInfo) => {
    const { centerLng, centerLat } = item;
    if (!(isNotEmpty(centerLng) && isNotEmpty(centerLat))) return;
    const lnglat = [+centerLng, +centerLat];
    // const path = item?.polygon?.map((item) => {
    //   return [+item.lng, +item.lat];
    // });
    const fillColor = item.inCluster ? markerActiveColorOption : markerDefaultColorOption;
    const polygon = new window.AMap.Polygon({
      path: item?.polygon,
      strokeOpacity: 1,
      fillOpacity: 0.2,
      strokeWeight: 1,
      strokeStyle: 'dashed',
      // zIndex: 60,
      anchor: 'bottom-center',
      bubble: true,
      extData: {
        id: item.id
      },
      ...fillColor
    });
    const marker = new window.AMap.Marker({
      position: lnglat,
      anchor: 'center',
      extData: item,
      content: `<div id="${item.id}"></div>`,
      bubble: true,
      zIndex: 20,
    });
    return [polygon, marker];
  };
  const renderBusinessName = (id, name, inCluster) => {
    const node = <div className={styles.businessNameWrapper}>
      <div
        className={cs(styles.markerContent, inCluster && styles.inCluster)}>
        <Typography.Text
          style={{ maxWidth: 165,
            color: '#fff',
            fontSize: 12,
          }}
          ellipsis={{ tooltip: name }}>
          {name}
        </Typography.Text>
      </div>
      <div className={cs(styles.point, inCluster && styles.inCluster)} />
    </div>;
    const el = document.getElementById(id);
    el && ReactDOM.render(node, el);
  };

  // 创建门店marker
  const createShopMarkers = (shopList: any) => {
    if (shopMarkersRef.current) {
      amapIns.remove(shopMarkersRef.current);
      shopMarkersRef.current = null;
    }
    if (!isNotEmptyAny(shopList)) return;

    const markers: any = [];
    shopList.forEach((shop) => {
      const marker = new window.AMap.Marker({
        anchor: 'bottom-center',
        position: new window.AMap.LngLat(+shop.lng, +shop.lat),
        // content: `<div id=${shop.id}></div>`,
        bubble: true,
      });
      const circle = new window.AMap.Circle({
        center: new window.AMap.LngLat(+shop.lng, +shop.lat),
        radius: shop?.protectRadius, // 半径（米）
        strokeWeight: 1,
        strokeOpacity: 1,
        fillOpacity: 0.2,
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        bubble: true, // 为了支持在商圈围栏上测距
        strokeColor: '#F53F3F', // 设置边框颜色
        fillColor: '#F53F3F', // 设置填充颜色
      });
      markers.push(marker, circle);
      hoverStore(marker, shop);
      // marker.on('mousemove', () => mouseMoveMarker(shop));
      // marker.on('mouseout', () => mouseOutMarker());
      amapIns.add(marker);
      amapIns.add(circle);

      showMarker(marker, <div className={styles.storeBox}>
        <img className={styles.outerImg} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_outer.png`}/>
        <img className={styles.innerImg} src={shop?.logo ? shop?.logo : `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_store_default.png`}/>
      </div>);
    });
    // const overlayGroup = new window.AMap.OverlayGroup(markers); // 围栏覆盖物群组
    // amapIns.add(overlayGroup); // 添加到地图
    shopMarkersRef.current = markers;
  };

  // 绘制周边的机会点
  const createSurroundChancePoint = (chancePointList) => {
    if (chancePointMarkerRef.current?.length) {
      amapIns.remove(chancePointMarkerRef.current);
      chancePointMarkerRef.current = [];
    }
    chancePointList?.forEach((value) => createSingleChancePoint(value));
  };
  const createSingleChancePoint = (value) => {
    // 剔除自身机会点
    // const { lng, lat } = centerMarkerRef?.current?.getPosition() || {};
    // if (value?.lng === lng && value?.lat === lat) return;

    const circle = new window.AMap.Circle({
      center: [value?.lng, value?.lat], // 圆心位置
      radius: value?.protectRadius, // 半径
      strokeColor: '#F53F3F', // 设置边框颜色
      fillColor: '#F53F3F', // 设置填充颜色
      fillOpacity: 0.1,
      strokeStyle: 'dashed',
      bubble: true,
    });

    const marker = new window.AMap.Marker({
      anchor: 'bottom-center',
      position: [value?.lng, value?.lat],
    });

    amapIns.add(circle);
    // 摩卡多&冲突时，只显示围栏不显示点位
    if (isMKD && value?.applyUserId) {
      chancePointMarkerRef.current.push(circle);
      return;
    };
    amapIns.add(marker);
    showMarker(marker, <IconFont iconHref='iconic_mendian-jihuidian' className='c-006 fs-24'/>);
    chancePointMarkerRef.current.push(marker, circle);
    if (value?.protectRadius) {
      hoverChancePointWithProtect(marker, value);
    } else {
      hoverChancePointWithoutProtect(marker, value);
    }
  };

  // 机会点没有区域保护
  const hoverChancePointWithoutProtect = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainerAddress}`);
      var pixel = amapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 80) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 80) {
        topBottom = 'bottom';
        offset[1] = -24;
      }
      if (x < 150) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 150) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      amapIns.add(hoverMarker);
      showMarker(hoverMarker, <div className={styles.chancePointContent}>
        <div className={styles.name}>{value?.regionName}</div>
        <div className={styles.status}>{value?.pointStatus}</div>
      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      amapIns.remove(hoverMarkerRef.current);
    });
  };
    // 机会点有区域保护
  const hoverChancePointWithProtect = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainerAddress}`);
      var pixel = amapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 190) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 190) {
        topBottom = 'bottom';
        offset[1] = -29;
      }
      if (x < 190) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 190) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      amapIns.add(hoverMarker);


      showMarker(hoverMarker, <div className={styles.storeContent}>
        <div className={styles.name}>{value?.regionName}</div>
        <div className={styles.status}>
          <span className={styles.protect}>区域保护中</span>
        </div>
        {value?.pointStatus ? <div className={styles.card}>
          <span className={styles.label}>机会点状态</span>
          <span className={styles.content}>{value?.pointStatus}</span>
        </div> : <></>}
        {value?.applyUserName ? <div className={styles.card}>
          <span className={styles.label}>保护申请人</span>
          <span className={styles.content}>{value?.applyUserName}</span>
        </div> : <></>}

        {isDef(value?.daysRemaining) ? <div className={styles.card}>
          <span className={styles.label}>保护有效期</span>
          <span className={styles.content}>剩余{value?.daysRemaining}天</span>
        </div> : <></>}

        {value?.protectRadiusStr ? <div className={styles.card}>
          <span className={styles.label}>保护范围</span>
          <span className={styles.content}>{value?.protectRadiusStr}</span>
        </div> : <></>}
      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      amapIns.remove(hoverMarkerRef.current);
    });
  };
    // 门店
  const hoverStore = (marker, value) => {
    // hover展示详情内容
    marker.on('mouseover', () => {
      const dom = document.querySelector(`.${mapContainerAddress}`);
      var pixel = amapIns.lngLatToContainer([value?.lng, value?.lat]);
      const { x, y } = pixel;
      const offset = [0, 0];
      let topBottom = 'top';
      let leftRight = 'center';
      if (y < 190) {
        topBottom = 'top';
      } else if ((dom?.clientHeight || 0) - y < 190) {
        topBottom = 'bottom';
        offset[1] = -29;
      }
      if (x < 190) {
        leftRight = 'left';
      } else if ((dom?.clientWidth || 0) - x < 190) {
        leftRight = 'right';
        offset[0] = -24;
      }
      const hoverMarker = new window.AMap.Marker({
        position: [value?.lng, value?.lat],
        anchor: `${topBottom}-${leftRight}`,
        offset,
        zIndex: 100
      });
      amapIns.add(hoverMarker);



      const background = value?.status === ShopStatus.Openning ? 'rgba(0,106,255,0.08)'
        : value?.status === ShopStatus.Delivered ? 'rgba(233, 248, 234, 1)'
          : 'rgba(146,165,202,0.07)';

      const color = value?.status === ShopStatus.Openning ? '#006AFF'
        : value?.status === ShopStatus.Delivered ? '#006F07'
          : '#222222';
      const isProtect = [ShopStatus.Signed, ShopStatus.Delivered, ShopStatus.Openning].includes(value?.status);
      showMarker(hoverMarker, <div className={styles.storeContent}>
        <div className={styles.name}>{value?.name}</div>
        <div className={styles.status}>
          {isProtect
            ? <span className={styles.protect}>区域保护中</span>
            : <></>}
          <span
            className={styles.storeStatus}
            style={{
              background,
              color,
              marginLeft: isProtect ? '4px' : '0'

            }}
          >{value?.statusName}</span>
        </div>

        <div className={styles.card}>
          <span className={styles.label}>保护有效期</span>
          <span className={styles.content}>永久保护</span>
        </div>

        {value?.protectRadiusStr ? <div className={styles.card}>
          <span className={styles.label}>保护范围</span>
          <span className={styles.content}>{value?.protectRadiusStr}</span>
        </div> : <></>}

      </div>);
      hoverMarkerRef.current = hoverMarker;
    });
    marker.on('mouseout', () => {
      amapIns.remove(hoverMarkerRef.current);
    });
  };
  useEffect(() => {
    if (!amapIns) return;
    updateClusterList(clusterList);
  }, [clusterList]);

  useEffect(() => {
    createShopMarkers(shopList);
    if (!amapIns) return;
  }, [shopList]);

  useEffect(() => {
    if (!amapIns) return;
    createSurroundChancePoint(chancePoint);
  }, [chancePoint]);

  return <div>

  </div>;
};
export default MapOfCIrcleAddress;
